export default {
  methods: {
    getArrayFromProduct(product, caseType) {
      return [
        product.sku,
        caseType ||
          product.case_types.find((c) => c.code?.includes('standard'))?.code,
        product.product_type_code,
      ].filter((i) => !!i)
    },
  },
}
